import { DatePicker, Form } from 'antd';

import { TFieldProps } from 'types';

const { Item } = Form;

export const FormDatePicker = ({
  name,
  label,
  rules,
  extra,
  tooltip,
  showTime,
  disabled,
  placeholder,
  inputStyles,
  itemClassName,
  onDateChange,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
    extra={extra}
  >
    <DatePicker
      inputReadOnly
      showNow={false}
      className='w-full'
      style={inputStyles}
      disabled={disabled}
      format={`YYYY/MM/DD hh:mm${showTime ? ':ss' : ''} A`}
      placeholder={placeholder}
      showTime={showTime && { format: 'hh:mm:ss A' }}
      onChange={onDateChange}
    />
  </Item>
);
